import angular from 'angular';
import mycrmConfirmation from './mycrmConfirmation';

export default angular
  .module('components.mycrmConfirmation', [])
  .component('mycrmConfirmation', mycrmConfirmation).name;
